import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AppConfigMatrixComponent} from '../components/app-config-matrix/app-config-matrix.component';
import {ConfigMatrix, ConfigMatrixValue} from '../../api-client-kt/src';
import {PortfolioDataContext, RefdataService} from '../data/portfolio-data-context.service';

@Component({
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        FormsModule,
        AppConfigMatrixComponent,
    ],
    template: `
        <div class="fullsize-vbox" style="gap: 20px">
            <app-app-config-matrix [matrix]="matrix0" [values]="values0" [refDataSvc]="this"></app-app-config-matrix>

            <app-app-config-matrix [matrix]="matrix1" [values]="values1" [refDataSvc]="this"></app-app-config-matrix>

            <app-app-config-matrix [matrix]="matrix2" [values]="values2" [refDataSvc]="this"></app-app-config-matrix>
        </div>
    `,
    styles: `
    `
})
export class TestConfigMatrixComponent implements AfterViewInit, RefdataService {

    private readonly grid = viewChild.required<any>('grid');
    protected matrix0 = matrices[0] as ConfigMatrix;
    protected values0 = matrixValues[this.matrix0.key!] as unknown as ConfigMatrixValue[];

    protected matrix1 = matrices[4] as ConfigMatrix;
    protected values1 = matrixValues[this.matrix1.key!] as unknown as ConfigMatrixValue[];

    protected matrix2 = matrices[3] as ConfigMatrix;
    protected values2 = matrixValues[this.matrix2.key!] as unknown as ConfigMatrixValue[];


    readonly refdataDelegate = new PortfolioDataContext();

    constructor() {
    }

    ngAfterViewInit(): void {
    }

    officeKeys(): string[] {
        return this.refdataDelegate.officeKeys();
    }

    lobKeys(): string[] {
        return this.refdataDelegate.lobKeys();
    }

    lookupLobName(lobKey: string): string {
        return this.refdataDelegate.lookupLobName(lobKey);
    }

    lookupOfficeName(officeKey: string): string {
        return this.refdataDelegate.lookupOfficeName(officeKey);
    }
}

const matrices = [{
    "id": "0a2a0014-9cbe-160e-819c-beb33e4e014e",
    "portfolio": "0a2a0014-9cbe-160e-819c-beb3359e0000",
    "key": "plr",
    "category": "Loss Ratios",
    "name": "plr",
    "description": "Net Loss Ratios for 2025",
    "valueType": "Percent",
    "keyType": "LobOffice"
}, {
    "id": "0a2a0014-9cbe-160e-819c-beb33fd00177",
    "portfolio": "0a2a0014-9cbe-160e-819c-beb3359e0000",
    "key": "nlr",
    "category": "Loss Ratios",
    "name": "nlr",
    "description": "Net Loss Ratios for 2025",
    "valueType": "Percent",
    "keyType": "LobOffice"
}, {
    "id": "0a2a0014-9cbe-160e-819c-beb3409d019f",
    "portfolio": "0a2a0014-9cbe-160e-819c-beb3359e0000",
    "key": "gnep",
    "category": "Premium",
    "name": "gnep",
    "description": "Net Loss Ratios",
    "valueType": "Amount",
    "keyType": "LobOffice"
}, {
    "id": "0a2a0014-9cbe-160e-819c-beb3418e01ca",
    "portfolio": "0a2a0014-9cbe-160e-819c-beb3359e0000",
    "key": "inflation_adj",
    "category": "Other",
    "name": "Inflation Adjustment",
    "description": "Inflation Adjustment",
    "valueType": "Percent",
    "keyType": "Lob"
}, {
    "id": "0a2a0014-9cbe-160e-819c-beb3423d01d2",
    "portfolio": "0a2a0014-9cbe-160e-819c-beb3359e0000",
    "key": "ilf_type",
    "category": "Other",
    "name": "ILF Type",
    "description": "ILF Type",
    "valueType": "Text",
    "keyType": "Lob"
}];

const matrixValues: any = {
    "plr":
        [{
            "officeKey": "ITA",
            "lobKey": "AVN",
            "value": 0.615974513379249,
            "valueText": null
        }, {"officeKey": "ESP", "lobKey": "AVN", "value": 0.472509321524508, "valueText": null}, {
            "officeKey": "GBR",
            "lobKey": "AVN",
            "value": 0.712434616753997,
            "valueText": null
        }, {"officeKey": "AUT", "lobKey": "CAS", "value": 0.62, "valueText": null}, {
            "officeKey": "CEE",
            "lobKey": "CAS",
            "value": 0.614783859534581,
            "valueText": null
        }, {"officeKey": "ASIA", "lobKey": "CAS", "value": 0.611534203911935, "valueText": null}, {
            "officeKey": "FRA",
            "lobKey": "CAS",
            "value": 0.611031800181308,
            "valueText": null
        }, {"officeKey": "GER", "lobKey": "CAS", "value": 0.654222147424248, "valueText": null}, {
            "officeKey": "ITA",
            "lobKey": "CAS",
            "value": 0.729382228013901,
            "valueText": null
        }, {"officeKey": "N2G", "lobKey": "CAS", "value": 0.57, "valueText": null}, {
            "officeKey": "ESP",
            "lobKey": "CAS",
            "value": 0.640765355842812,
            "valueText": null
        }, {"officeKey": "GBR", "lobKey": "CAS", "value": 0.71261163347199, "valueText": null}, {
            "officeKey": "FRA",
            "lobKey": "CYB",
            "value": 0.59,
            "valueText": null
        }, {"officeKey": "GER", "lobKey": "CYB", "value": 0.640846555255308, "valueText": null}, {
            "officeKey": "ITA",
            "lobKey": "CYB",
            "value": 0.568409885181277,
            "valueText": null
        }, {"officeKey": "ESP", "lobKey": "CYB", "value": 0.795423606386125, "valueText": null}, {
            "officeKey": "GBR",
            "lobKey": "CYB",
            "value": 0.715437768351467,
            "valueText": null
        }, {"officeKey": "CEE", "lobKey": "FLS", "value": 0.592127642667684, "valueText": null}, {
            "officeKey": "ASIA",
            "lobKey": "FLS",
            "value": 0.492911524133677,
            "valueText": null
        }, {"officeKey": "FRA", "lobKey": "FLS", "value": 0.592467122178287, "valueText": null}, {
            "officeKey": "GER",
            "lobKey": "FLS",
            "value": 0.611096546529699,
            "valueText": null
        }, {"officeKey": "ITA", "lobKey": "FLS", "value": 0.637910751339555, "valueText": null}, {
            "officeKey": "ESP",
            "lobKey": "FLS",
            "value": 0.654530806082812,
            "valueText": null
        }, {"officeKey": "GBR", "lobKey": "FLS", "value": 0.696033408372369, "valueText": null}, {
            "officeKey": "CEE",
            "lobKey": "MAR",
            "value": 0.483555789577776,
            "valueText": null
        }, {"officeKey": "ASIA", "lobKey": "MAR", "value": 0.589637466419832, "valueText": null}, {
            "officeKey": "FRA",
            "lobKey": "MAR",
            "value": 0.586556591742433,
            "valueText": null
        }, {"officeKey": "ITA", "lobKey": "MAR", "value": 0.757093832395422, "valueText": null}, {
            "officeKey": "ESP",
            "lobKey": "MAR",
            "value": 0.671799824137639,
            "valueText": null
        }, {"officeKey": "GBR", "lobKey": "MAR", "value": 0.668503254799466, "valueText": null}, {
            "officeKey": "GBR",
            "lobKey": "PAR",
            "value": 0.65,
            "valueText": null
        }, {"officeKey": "CEE", "lobKey": "PRP", "value": 0.538761452024594, "valueText": null}, {
            "officeKey": "ASIA",
            "lobKey": "PRP",
            "value": 0.631916348427674,
            "valueText": null
        }, {"officeKey": "AUT", "lobKey": "PRP", "value": 0.718726752788494, "valueText": null}, {
            "officeKey": "FRA",
            "lobKey": "PRP",
            "value": 0.59422946372753,
            "valueText": null
        }, {"officeKey": "GER", "lobKey": "PRP", "value": 0.678441830958514, "valueText": null}, {
            "officeKey": "ITA",
            "lobKey": "PRP",
            "value": 0.691732357640148,
            "valueText": null
        }, {"officeKey": "N2G", "lobKey": "PRP", "value": 0.54, "valueText": null}, {
            "officeKey": "ESP",
            "lobKey": "PRP",
            "value": 0.630185467998421,
            "valueText": null
        }, {"officeKey": "GBR", "lobKey": "PRP", "value": 0.644061628615128, "valueText": null}
        ],
    "inflation_adj": [{"officeKey": "*", "lobKey": "AVN", "value": 0.03213, "valueText": null}, {
        "officeKey": "*",
        "lobKey": "CAS",
        "value": 0.00763,
        "valueText": null
    }, {"officeKey": "*", "lobKey": "CYB", "value": 0.01857, "valueText": null}, {
        "officeKey": "*",
        "lobKey": "FLS",
        "value": 0.007427675,
        "valueText": null
    }, {"officeKey": "*", "lobKey": "MAR", "value": 0.01234, "valueText": null}, {
        "officeKey": "*",
        "lobKey": "PRP",
        "value": 0.00657,
        "valueText": null
    }, {"officeKey": "*", "lobKey": "PAR", "value": 0.0, "valueText": null}],
    "ilf_type": [{"officeKey": "*", "lobKey": "AVN", "value": null, "valueText": "FLC"}, {
        "officeKey": "*",
        "lobKey": "CAS",
        "value": null,
        "valueText": "ILF"
    }, {"officeKey": "*", "lobKey": "CYB", "value": null, "valueText": "ILF"}, {
        "officeKey": "*",
        "lobKey": "FLS",
        "value": null,
        "valueText": "ILF"
    }, {"officeKey": "*", "lobKey": "MAR", "value": null, "valueText": "FLC"}, {
        "officeKey": "*",
        "lobKey": "PRP",
        "value": null,
        "valueText": "FLC"
    }, {"officeKey": "*", "lobKey": "PAR", "value": null, "valueText": "ILF"}]

};
